import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-language-edit',
  templateUrl: './language-edit.component.html',
  styleUrls: ['./language-edit.component.css']
})
export class LanguageEditComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
